import { Box, Checkbox } from "@mui/material";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import { blueishWhiteColor, cloudyIndigoColor, darkBlueShadeColor, lightWhiteColor, violetShadeColor, white } from "../../config/ColorObj";
import OutletProductTable from "./OutletProductTable";

const OutletCard = ({
    outlet,
    offerIndex,
    outletIndex,
    offer,
    isSelected,
    isExpanded,
    onOutletCheckboxChange,
    onToggleProductRow,
}) => {
    return (
        <Box
            sx={{
                marginBottom: "10px",
                border: "1px solid #e5e7eb",
                borderRadius: "10px",
                background: isSelected ? lightWhiteColor : white,
                borderLeft: isSelected ? "4px solid #667eea" : "1px solid #e5e7eb",
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                px: 0.5,
                py: 0.5,
            }}
        >
            {/* Outlet Header */}
            <Box
                onClick={() => onToggleProductRow(offerIndex, outletIndex)}
                sx={{
                    background: blueishWhiteColor,
                    padding: "18px 20px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                    <Checkbox
                        checked={isSelected || false}
                        onChange={(e) => {
                            e.stopPropagation();
                            onOutletCheckboxChange(offerIndex, outletIndex, outlet, offer);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            color: violetShadeColor,
                            "& .MuiSvgIcon-root": { fontSize: 24 },
                        }}
                    />
                    <Box sx={{ ml: 2 }}>
                        <TypographyCompo
                            sx={{
                                fontWeight: 700,
                                fontSize: "17px",
                                color: darkBlueShadeColor,
                                letterSpacing: "0.3px",
                            }}
                        >
                            {outlet.outletName}
                        </TypographyCompo>
                        <TypographyCompo
                            sx={{
                                fontSize: "13px",
                                color: cloudyIndigoColor,
                                marginTop: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                            }}
                        >
                            <span
                                style={{
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    background: violetShadeColor,
                                    display: "inline-block",
                                }}
                            ></span>
                            Beat: {outlet.beatName}
                        </TypographyCompo>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        gap: 3,
                        alignItems: "center",
                    }}
                >
                    <Box sx={{ textAlign: "right" }}>
                        <TypographyCompo
                            sx={{
                                fontSize: "11px",
                                color: cloudyIndigoColor,
                                fontWeight: 500,
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                            }}
                        >
                            Taxable
                        </TypographyCompo>
                        <TypographyCompo
                            sx={{
                                fontSize: "15px",
                                fontWeight: 700,
                                color: darkBlueShadeColor,
                                marginTop: "2px",
                            }}
                        >
                            ₹{outlet.taxableAmount}
                        </TypographyCompo>
                    </Box>

                    <Box sx={{ textAlign: "right" }}>
                        <TypographyCompo
                            sx={{
                                fontSize: "11px",
                                color: cloudyIndigoColor,
                                fontWeight: 500,
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                            }}
                        >
                            Tax
                        </TypographyCompo>
                        <TypographyCompo
                            sx={{
                                fontSize: "15px",
                                fontWeight: 700,
                                color: darkBlueShadeColor,
                                marginTop: "2px",
                            }}
                        >
                            ₹{outlet.totalTaxAmt}
                        </TypographyCompo>
                    </Box>

                    <Box sx={{ textAlign: "right" }}>
                        <TypographyCompo
                            sx={{
                                fontSize: "11px",
                                color: cloudyIndigoColor,
                                fontWeight: 500,
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                            }}
                        >
                            Total
                        </TypographyCompo>
                        <TypographyCompo
                            sx={{
                                fontSize: "15px",
                                fontWeight: 700,
                                color: darkBlueShadeColor,
                                marginTop: "2px",
                            }}
                        >
                            ₹{outlet.totalAmount}
                        </TypographyCompo>
                    </Box>

                    <Box
                        sx={{
                            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.25s ease",
                            color: violetShadeColor,
                            fontSize: "18px",
                        }}
                    >
                        ▾
                    </Box>
                </Box>
            </Box>

            {/* Expanded Product Table */}
            {isExpanded && <OutletProductTable items={outlet.items} isSelected={isSelected} />}
        </Box>
    );
};

export default OutletCard;